import React, { Component } from 'react'
import App from '../App';
import {Link} from 'react-router-dom';
import logo from '../logo.svg';
import styled from 'styled-components';
import {ButtonContainer} from './Button';
import {loginEmailPassword} from '../firebase'

export default class Navbar extends Component {
    render() {
        return (
            <NavWrapper className="navbar nav-bar-expand-sm navbar-dark px-sm-5">
               <Link to='/'>
                  <img src={logo} alt="store" className="navbar-brand" />
               </Link> 
               <ul className="navbar-nav align-items-center">
                 <li className="nav-item ml-5">
                    <Link to="/" className="nav-link">
                       Products

                       {/* a function to provide data for the page, this called data layer */}
                        
                       
                    </Link>
                 </li>
               </ul>
               <ul className="navbar-nav align-items-center">
               <Link to="/login" className="ml-auto">
                  <ButtonContainer>
                      <i className="fas fa-cart-plus">LOGIN</i>
                  </ButtonContainer>
               </Link>
               </ul>
               <Link to="/cart" className="ml-auto">
                  <ButtonContainer>
                      <i className="fas fa-cart-plus">my cart</i>
                  </ButtonContainer>
               </Link>
            </NavWrapper>
        )
    }
}
const NavWrapper = styled.nav`
background:var(--mainBlue);
.nav-link{
    color:var(--mainWhite) !important;
    font-size:1.3 rem;
    text-transform:capitalize;
}
`;
